import { Component, OnInit } from '@angular/core';
import { UsuarioRegistrarModel } from 'src/app/models/seguridad/UsuarioRegistrarModel';
import { IUsuarioRegistrarModel } from 'src/app/models/interfaces/seguridad/IUsuarioRegistrarModel';
import { StorageService } from 'src/app/services/storage/storage.service';
import { Roles, TipoUsuario } from 'src/app/models/common/enumModel';
import { OktaAuthService } from 'src/app/services/OktaAuth/okta-auth.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  user!: UsuarioRegistrarModel;
  isAuthenticated: boolean = false;
  idTipoUsuario: number = 0;
  usuarioEngie = TipoUsuario.Empleado;
  usuarioContratista = TipoUsuario.Contratista;

  esAdministrador: boolean = false;
  esCoordinador: boolean = false;
  esSolicitante: boolean = false;
  esRevisor: boolean = false;
  esSupervisor: boolean = false;
  esVigilante: boolean = false;
  esAdministradorSSO: boolean = false;

  constructor(private storageService: StorageService,
    public oktaAuth: OktaAuthService) {
   }

   async ngOnInit() {
    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    
    // console.log("Okta: ");
    // console.log(this.isAuthenticated);

    if(!this.isAuthenticated)
      this.isAuthenticated = this.storageService.isAuthenticated();    
    // console.log("autenticado:" + this.isAuthenticated);
    if(this.isAuthenticated){
      let usuario = this.storageService.getCurrentUser();
      this.idTipoUsuario = usuario.idTipo;
      this.esAdministrador = usuario.esAdministrador;
      this.esCoordinador = usuario.selectedRoles.find(p => p === Roles.COORDINADOR_SSO)? true : false;
      this.esSolicitante = usuario.selectedRoles.find(p => p === Roles.SOLICITANTE)? true : false;
      this.esSupervisor = usuario.selectedRoles.find(p => p === Roles.SUPERVISOR)? true : false;
      this.esRevisor = usuario.selectedRoles.find(p => p === Roles.REVISOR)? true : false; 
      this.esVigilante = usuario.selectedRoles.find(p => p === Roles.VIGILANTE)? true : false;     
      this.esAdministradorSSO = usuario.selectedRoles.find(p => p === Roles.ADMINISTRADORSSO)? true : false;   
    }    

    this.storageService.getEmitter().subscribe((value: IUsuarioRegistrarModel) => {
      this.user = value;
      if(this.user.isLogged){
        this.isAuthenticated = true;
        this.idTipoUsuario = value.idTipo;
        this.esAdministrador = value.esAdministrador;
        this.esCoordinador = value.selectedRoles.find(p => p === Roles.COORDINADOR_SSO)? true : false;
        this.esSolicitante = value.selectedRoles.find(p => p === Roles.SOLICITANTE)? true : false;
        this.esSupervisor = value.selectedRoles.find(p => p === Roles.SUPERVISOR)? true : false;
      }
      else{
        this.isAuthenticated = false;   
      }
      // console.log("usuario:");
      // console.log(this.user);
    });
  }

}
